/**
 * Whether an endpoint is a mutation the toast middleware reports: its name starts with "add", "create",
 * "update" or "delete" (case-insensitive).
 */
export const isMutationName = (name: string) =>
  /^(add|create|update|delete)/i.test(name);
